const productDetails = {
  EmersonItemCode: "Emerson Item Code",
  VendorItemCode: "Vendor Item Code",
  Description: "Description",
  Ingredients: "Ingredients",
  DietaryConsiderations: "Dietary considerations",
  SuggestedUse: "Suggested use",
  Warnings: "Warnings",
  FreeShipping: "FREE Shipping on orders over <1>{{amount}}!</1>",
  YourPrice: "Your price: ",
  MSRP: " | MSRP: ",
  RemainingUntilFreeShipping: "You're <1>{{amount}}</1> away from FREE shipping on this order!",
  contactQuestions:
    "Questions? Visit our <1>Help Center</1> or contact our support team: <3>Chat</3>, <5>Email</5> or Call 800-654-4432",
  contactAvailable: "Call and Chat available",
  contactTimeframe: "M-F 9:00 AM - 8:00 PM EST",
  Featured: "Featured",
  New: "New",
  tooltips: {
    heatSensitive: "Heat sensitive",
    shortShelfLife: "Short shelf life of 6 months or less",
  },
  SelectSize: "Select size",
  SelectQuantity: "Quantity",
  ServingsPerContainer: "<0>Servings per container:</0> {{servingsPerContainer}}",
  ServingSize: "<0>Serving size:</0> {{servingSize}}",
  OtherIngredients: "Other Ingredients: {{otherIngredients}}",
  Ingredient: "Ingredient",
  Quantity: "Quantity",
  RestockReminderOn: "You'll receive an email when in stock",
  CongratsYouHaveFreeShipping: "Your shipping is free!",
  Unauthenticated: "<0>Sign in</0> to see pricing and more details",
} as const;

export { productDetails };
